export const DIFFUSIONS_TIME_FORMAT = 'dddd D MMMM – H[h]mm';
export const PROGRAM_TIME_FORMAT = 'dddd D MMMM [à] H[h]mm';

export const GLOBAL_MAX_SCORE = 5;
export const TELERAMA_MAX_SCORE = 3;

export const COVER_IMG_HEIGHT = 480;
